import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ProductSale } from '../../../interfaces/tickets/ProductSale';
import { NgPaymentService } from '../../../services/payment.service';
import { Address } from '../../../interfaces';
import { ModalCoreComponent } from '../../modal-core/modal.component';

@Component({
  selector: 'ng-tickets-address-list',
  styleUrls: ['./address-list.component.scss', '../../tickets/styles/ticket.scss'],
  template: `
    <section [ngClass]="{'loading': loading}">
      <ng-core-loading *ngIf="loading"></ng-core-loading>

      <div *ngIf="!loading && !error">
        <div class="card-list">
          <h2 class="title-section">Endereço de cobrança</h2>

          <ul class="address-list">
            <li class="address-item" *ngFor="let address of addresses">

              <div class="address-info" (click)="selectAddress(address)">
                <div class="address-description">{{ address.line_1 }} {{ address?.line_2 ? ' - ' + address?.line_2 : '' }}</div>
                <div class="address-location">{{address.city}}, {{address.state}} - {{address.zip_code}}</div>
              </div>

              <div class="remove-container">
                <span class="fa fa-remove" (click)="openDeleteAddressModal(address.id)"></span>
              </div>

              <div class="radio-container" (click)="selectAddress(address)">
                <input
                  class="radio-type-ticket"
                  id="radio_{{address.id}}"
                  name="typeTicket"
                  type="radio"
                  [value]="address"
                  [checked]="isChecked(address)"/>

                <label for="radio_{{address.id}}">
                  <span class="fa fa-check"></span>
                </label>
              </div>
            </li>
          </ul>

          <div class="btn-add-address" (click)="productSale.billing_address = null; nextStep.emit('add-address')">
            Adicionar <i class="fa fa-plus"></i>
          </div>

          <div class="container-button">
            <button class="btn btn-pink" (click)="productSale.billing_address = null; nextStep.emit('add-card')">
              <i class="fa fa-chevron-left"></i> Voltar</button>

            <button class="btn btn-pink" (click)="nextStep.emit('card-confirm')" [disabled]="!productSale?.billing_address?.id">
              Validar dados<i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="!loading && error">
        <p>{{error}}</p>
        <div class="container-button">
          <button class="btn btn-pink" (click)="nextStep.emit('product-list')"><i class="fa fa-chevron-left"></i> Voltar</button>
        </div>
      </div>
    </section>

    <ng-core-modal #deleteAddressModal [title]="'Excluir endereço'" [config]="{ ignoreBackdropClick: true }">
      <p>Tem certeza que deseja excluir este endereço da sua conta?</p>

      <div class="container-button">
        <button class="btn btn-pink-contrast" (click)="deleteAddressModal.closeModal()"> Cancelar</button>
        <button class="btn btn-pink" (click)="removeAddress(selectedAddress)"> Excluir</button>
      </div>
    </ng-core-modal>
  `
})
export class AddressListComponent implements OnInit {

  @Input() productSale: ProductSale;
  @Output() nextStep = new EventEmitter();
  @ViewChild('deleteAddressModal') modal: ModalCoreComponent;

  addresses: Address[] = [];
  loading = true;
  error: string = null;
  selectedAddress: string;

  constructor(private paymentService: NgPaymentService) {}

  ngOnInit() {
    this.getAddressList();
  }

  getAddressList() {
    this.paymentService.getAddresses().subscribe(response => {
      this.addresses = response.data;
      this.productSale.addressLength = response.data.length;

      if (response.data.length) {
        this.loading = false;
      } else {
        this.nextStep.emit('add-address');
      }

    }, () => {
      this.error = 'Ocorreu um erro ao recuperar a lista de endereços da sua conta. Por favor tente novamente.';
      this.loading = false;
    });
  }

  removeAddress(id) {
    const { billing_address } = this.productSale;
    this.modal.closeModal();
    this.loading = true;

    this.paymentService.deleteAddress(id).subscribe(address => {
      this.addresses = this.addresses.filter(el => el.id !== address.id);
      this.loading = false;

      if (billing_address && billing_address.id && billing_address.id === id) {
        this.productSale.billing_address = null;
      }
    }, () => {
      this.error = 'Ocorreu um erro ao tentar excluir este endereço. Por favor tente novamente.';
      this.loading = false;
    });
  }

  selectAddress(address) {
    this.productSale.billing_address = address;
  }

  isChecked(address) {
    return (
      this.productSale.billing_address &&
      this.productSale.billing_address.id === address.id
    );
  }

  openDeleteAddressModal(addressId) {
    this.selectedAddress = addressId;
    this.modal.openModal();
  }
}
